// Client-side session helper. Server validates via cookie middleware in self-host.
// In local preview (no Postgres session store), we use a simple cookie set by /api/auth/login.
export interface SessionUser {
  id: string;
  email: string;
  name: string;
  role: "super_admin" | "admin" | "developer" | "staff" | "family" | "viewer" | "member" | string;
  tier?: string;
}

const KEY = "aiws.session";

export function getSession(): SessionUser | null {
  if (typeof window === "undefined") return null;
  try {
    const raw = localStorage.getItem(KEY);
    return raw ? (JSON.parse(raw) as SessionUser) : null;
  } catch {
    return null;
  }
}

export function setSession(user: SessionUser | null) {
  if (typeof window === "undefined") return;
  if (!user) localStorage.removeItem(KEY);
  else localStorage.setItem(KEY, JSON.stringify(user));
  window.dispatchEvent(new Event("aiws.session"));
}

export function useSessionListener(cb: () => void) {
  if (typeof window === "undefined") return () => {};
  window.addEventListener("aiws.session", cb);
  window.addEventListener("storage", cb);
  return () => {
    window.removeEventListener("aiws.session", cb);
    window.removeEventListener("storage", cb);
  };
}
